import { RX0006 } from "../rxTypeCode";

export const SET_RELATIONSHIP = "SET_RELATIONSHIP" + RX0006;
export const SET_RELATIONSHIPNAME = "SET_RELATIONSHIPNAME" + RX0006;
export const SET_RELATIONSHIPREMARK = "SET_RELATIONSHIPREMARK" + RX0006;

export const GET_ALLOWED_RELATIONSHIPS_REQUEST = "GET_ALLOWED_RELATIONSHIPS_REQUEST" + RX0006;
export const GET_ALLOWED_RELATIONSHIPS_SUCCESS = "GET_ALLOWED_RELATIONSHIPS_SUCCESS" + RX0006;
export const GET_ALLOWED_RELATIONSHIPS_FAILURE = "GET_ALLOWED_RELATIONSHIPS_FAILURE" + RX0006;
export const CLEANUP = "CLEANUP" + RX0006;
